import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { KpisComponent } from "./kpis/kpis.component";
import { SharedModule } from "../../shared/shared.module";
import { LayoutModule } from "@angular/cdk/layout";
import { OverviewComponent } from "./overview.component";
import { RouterModule } from "@angular/router";
import { InfosComponent } from "./infos/infos.component";
import { CityComponent } from "./kpis/city/city.component";
import { ReminderComponent } from "./reminder/reminder.component";
import { BizzmineComponent } from "./bizzmine/bizzmine.component";
import { MaterialModule } from "../../shared/material.module";

@NgModule({
    declarations: [
        OverviewComponent,
        KpisComponent,
        InfosComponent,
        CityComponent,
        ReminderComponent,
        BizzmineComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        MaterialModule,
        LayoutModule,
        RouterModule,
    ],
})
export class OverviewModule {}
